import { Component, Input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-patient-group-cell',
  templateUrl: './patient-group-cell.component.html',
  styleUrls: ['./patient-group-cell.component.scss'],
})
export class PatientGroupCellComponent {
  @Input() name: string;
  @Input() patientCount: number;
}
